/** The master table's Buyer cell text: the row's distinct codes, or null when none is coded. */
export function buyerCodesLabel(codes: readonly string[]): string | null {
  return codes.length === 0 ? null : codes.join(', ');
}
